import { Injectable } from '@angular/core';
import { ConfigService } from '../../configuration/services/config.service';
import { ErrorBase } from '../../errors/error.base';
import { PITEventService } from '../../event/pit.event.service';
import { LoggingService } from '../../logging/logging.service';
import { BaseService } from '../../services/misc/base.service';
import { UtilsMisc } from '../../utils/utils.misc';
import { UtilsString } from '../../utils/utils.string';
import { IErrorService } from '../interfaces/error.service.interface';

@Injectable({
    providedIn: 'root'
})
export class ErrorService extends BaseService implements IErrorService {

    constructor(configurationService: ConfigService, loggingService: LoggingService, protected eventService: PITEventService) {
        super(configurationService, loggingService);

        this.eventService.registerMethod('error.log', (error: any) => {
            this.eventService.sendEvent('error', {
                error: error,
                showDialog: false
            });
        });
        this.eventService.registerMethod('error.show', (error: any) => {
            this.eventService.sendEvent('error', {
                error: error,
                showDialog: true
            });
        });
        this.eventService.subscribeForEvent('error', this.handleErrorEventAsync.bind(this));

        this.loggingService.debug('ErrorService --> constructor()');
    }

    public async handleErrorAsync(error: any, showDialog: boolean = false): Promise<void> {
        await this.doHandleErrorAsync(error, showDialog);
    }

    /*public parseError(error: any): string[] {
        return this.doParseError(error);
    }*/

    public async showErrorAsync(error: any): Promise<void> {
        return (await this.doShowErrorAsync(error));
    }

    protected async doHandleErrorAsync(error: any, showDialog: boolean = false): Promise<void> {
        // Don't log success status codes as errors
        if (error && error.status && error.status >= 200 && error.status < 300) {
            return;
        }

        this.loggingService.error(error);

        if (showDialog === true) {
            await this.showErrorAsync(error)
        }
    }

    /*protected doParseError(error: any): string[] {
        let result: string[] = [];

        let errorMessage: string = null;
        if (UtilsMisc.isNullOrUndefined(error.error) === false) {
            if (UtilsString.stringIsNullOrEmpty(error.error.errorMessage) === false) {
                errorMessage = error.error.errorMessage;
            } else if (UtilsString.stringIsNullOrEmpty(error.error.exception) === false) {
                errorMessage = error.error.exception;
            }
        } else if (UtilsMisc.isNullOrUndefined(error.statusText) === false) {
            errorMessage = error.statusText;
        }
        if (UtilsString.stringIsNullOrEmpty(errorMessage) === false) {
            const errorMessageArray: string[] = errorMessage.split(';');
            if ((UtilsMisc.isNullOrUndefined(errorMessageArray) === false) && (errorMessageArray.length > 0)) {
                errorMessageArray.forEach(item => {
                    result.push(item);
                });
            }
        }


        return result;
    }*/

    protected async doShowErrorAsync(error: any): Promise<void> {
        let errorMessage: string = '';
        let errorTitle: string = 'Fehler';

        // Extract error message from various error structures
        if (UtilsMisc.isNullOrUndefined(error.error) === false) {
            if (UtilsString.stringIsNullOrEmpty(error.error.errorMessage) === false) {
                errorMessage = error.error.errorMessage;
            } else if (UtilsString.stringIsNullOrEmpty(error.error.exception) === false) {
                errorMessage = error.error.exception;
            }
        } else if (UtilsString.stringIsNullOrEmpty(error.message) === false) {
            errorMessage = error.message;
        } else if (UtilsString.stringIsNullOrEmpty(error.statusText) === false) {
            errorMessage = error.statusText;
        } else {
            errorMessage = 'Ein unbekannter Fehler ist aufgetreten.';
        }

        // Set title based on error status
        if (error && error.status) {
            errorTitle = `Fehler (${error.status})`;
        }

        // Send confirmation event to display modal error dialog
        this.eventService.sendEvent('confirmation', {
            message: errorMessage,
            header: errorTitle,
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'OK',
            rejectLabel: null, // Hide cancel button for error dialogs
            callback: {
                method: async (confirmed: boolean) => {
                    // No action needed for error confirmations
                },
                data: null
            }
        });
    }

    protected async handleErrorEventAsync(event: any): Promise<void> {
        await this.handleErrorAsync(event.error, event.showDialog);
    }

}
